import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {inject} from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  console.log('🛡️ [Guard] Vérification de l\'authentification...');
  console.log('🛡️ [Guard] URL demandée:', state.url);
  console.log('🛡️ [Guard] isAuthenticated:', authService.isAuthenticated());

  if (authService.isAuthenticated()) {
    console.log('✅ [Guard] Utilisateur authentifié, accès autorisé');
    return true;
  }

  console.log('🔐 [Guard] Non authentifié, démarrage du flux de connexion...');

  // Sauvegarder l'URL demandée pour rediriger après login
  const targetUrl = state.url;
  console.log('💾 [Guard] URL cible sauvegardée:', targetUrl);

  // Démarrer le flux OAuth
  authService.login();

  console.log('🔐 [Guard] initCodeFlow() appelé, redirection vers le serveur d\'autorisation...');

  return false;
};
